import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import React from "react";
import { DATA_TYPES, FONTS } from "../../constants";
import { stateType, stateTypeF } from "../../state";
import { calcNumericHistData } from "./DistributionBox";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(0),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(0),
    },
    container: { display: "flex", flexDirection: "column" },
  })
);

export function getCols(state: stateTypeF, colType: string) {
  return state.saveState.dataset.columns.filter(
    (col) => col.columnType === colType
  );
}

export function NumericDropDown({ state }: stateType) {
  const classes = useStyles();
  let nCols = getCols(state, DATA_TYPES.number).length;
  if (nCols === 0) {
    return <div></div>;
  }

  const handleChange = (
    event: React.ChangeEvent<{ value: unknown }>,
    state: stateTypeF
  ) => {
    const columnName = event.target.value as string;
    state.saveState.dataUpload.numericHistSelected = columnName;
    calcNumericHistData(state);
  };

  return (
    <div className={classes.container}>
      <FormControl className={classes.formControl} disabled={state.isBusy}>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={state.saveState.dataUpload.numericHistSelected}
          onChange={(e) => handleChange(e, state)}
          inputProps={{
            name: "numericDropdown",
            id: "age-native-simple",
          }}
          disableUnderline
          style={{ fontFamily: FONTS, color: "grey" }}
        >
          {getCols(state, DATA_TYPES.number).map((n) => (
            <MenuItem value={n.columnName}>{n.columnName}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
